<template>
    <formFieldRow
        v-if="show"
        :name="name"
        :label="label"
        :labelWidthClass="labelWidthClass"
        :errors="errors"
        :required="required"
    >
        <template #default="{ hasError }">
            <slot :hasError="hasError"></slot>
        </template>
    </formFieldRow>
</template>

<script>
import formFieldRow from './formFieldRow.vue';

/*
Example:
const rules = {
    title: { required: true, show: true },
    surname: { required: true, show: true }
};
*/

export default {
    components: {
        formFieldRow
    },
    props: {
        name: { type: [String, Array], required: true },
        label: { type: String },
        labelWidthClass: { default: 'sm:w-32' },
        errors: { default: {} },
        rules: { type: Object, required: true }
    },
    computed: {
        keys() {
            return Array.isArray(this.name) ? this.name : [this.name];
        },
        matchedRulesArray() {
            return this.keys.reduce((a, c) => {
                const rule = this.rules[c];
                if (rule) {
                    a.push(rule);
                }
                return a;
            }, []);
        },
        required() {
            return this.matchedRulesArray.some(r => r && r.required);
        },
        show() {
            return this.matchedRulesArray.some(
                r => r && (r.show || r.required)
            );
        }
    }
};
</script>
